// src/services/deepseekService.js

const GROQ_API_KEY = process.env.REACT_APP_GROQ_API_KEY || '';
const OPENROUTER_API_KEY = process.env.REACT_APP_OPENROUTER_API_KEY || '';

export class DeepSeekService {
  async transcribeAudio(audioBlob) {
    const formData = new FormData();
    formData.append('file', audioBlob, 'audio.webm');
    formData.append('model', 'whisper-large-v3');
    formData.append('response_format', 'text');

    const res = await fetch('https://api.groq.com/openai/v1/audio/transcriptions', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${GROQ_API_KEY}`,
      },
      body: formData,
    });

    if (!res.ok) {
      const msg = await res.text();
      throw new Error(`Whisper falhou: ${res.status} – ${msg}`);
    }

    const text = await res.text(); // ← resposta é texto puro
    return { text };
  }

  async formatTranscription(rawText) {
    const prompt = `
Você é um assistente médico especializado em documentação clínica.
Formate a seguinte transcrição conforme o modelo médico estruturado:

TRANSCRIÇÃO: ${rawText}

FORMATO DE SAÍDA:
**HISTÓRIA CLÍNICA ESTRUTURADA**

**1. QUEIXA PRINCIPAL (QP):**
...

**2. HISTÓRIA DA DOENÇA ATUAL (HDA):**
...

**3. ANTECEDENTES PESSOAIS (AP):**
...

**4. ANTECEDENTES FAMILIARES (AF):**
...

**5. EXAME FÍSICO:**
...

**6. HIPÓTESES DIAGNÓSTICAS:**
...

**7. CONDUTA:**
...
`;

    const res = await fetch('https://openrouter.ai/api/v1/chat/completions', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${OPENROUTER_API_KEY}`,
        'Content-Type': 'application/json',
        'HTTP-Referer': window.location.origin,
        'X-Title': 'Transcritor Médico',
      },
      body: JSON.stringify({
        model: 'deepseek/deepseek-chat',
        messages: [{ role: 'user', content: prompt }],
        temperature: 0.3,
        max_tokens: 1200,
      }),
    });

    if (!res.ok) {
      const error = await res.text();
      throw new Error(`Formatting failed: ${res.status} – ${error}`);
    }

    const data = await res.json();
    return data.choices?.[0]?.message?.content || rawText;
  }
}
